import API from './axios.js';

export const getallBranchNames = (companyID) => API.get(`branch/by-company/${companyID}`);

export const getBranchByBranchID = (branchId) => API.get(`branch/${branchId}`);


export const addMembersManually = (payload) => API.post("branch/add-users", payload);
export const updateMembersManually =  (branchId,payload) => API.patch(`branch/${branchId}`,payload);


export const addBranch = (credentials) => API.post('branch', credentials);
export const getBranchDetailsById =  (branchId) => API.get(`branch/${branchId}`);


export const uploadUsersSpreadsheet = (branchId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("branchId", branchId);

  return API.post("branch/add-users-spreadsheet", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};